export default {
  bind(el, binding, vnode) {
    if (!binding.value) {
      return
    }
    const imageUrl = binding.value
    const allTableBody = el.querySelector('.el-table__body-wrapper')
    allTableBody.style.setProperty('background-image', 'url('+ imageUrl +')')
  },
  update(el, binding, vnode) {
    if (!binding.value) {
      return
    }
    const imageUrl = binding.value
    const allTableBody = el.querySelector('.el-table__fixed')
    allTableBody && allTableBody.style.setProperty('background-image', 'url('+ imageUrl +')')
  }
}



// WEBPACK FOOTER //
// ./src/directive/watermark/mark.js